module.exports = __webpack_public_path__ + "d4ad8dbf878487ee1f314b6345229ac3.fbx";